const GUARDED_ATTR = 'data-image-guard';
const MASK_CLASS = 'image-guard-mask';
const HOST_CLASS = 'image-guard-host';
const SKIP_CLASS = 'image-guard-skip';

function shouldSkip(img) {
  if (!img || img.tagName !== 'IMG') return true;
  if (img.classList.contains(SKIP_CLASS)) return true;
  if (img.classList.contains('new-badge')) return true;
  if (img.closest(`.${SKIP_CLASS}`)) return true;
  return false;
}

/**
 * 遮罩只挂在图片组件容器上，避免挂到 image-wrapper 等大容器挡点击。
 */
function getImageContainer(img) {
  const vanImage = img.closest('.van-image');
  if (vanImage) return vanImage;

  const parent = img.parentElement;
  if (!parent) return null;

  // 商品卡 image-wrapper 内已有 van-image 单独加遮罩，角标等小图跳过
  if (parent.classList.contains('image-wrapper') && parent.querySelector('.van-image')) {
    return null;
  }

  return parent;
}

function ensureMask(container) {
  if (!container || container.querySelector(`.${MASK_CLASS}`)) return;

  container.classList.add(HOST_CLASS);

  const style = window.getComputedStyle(container);
  if (style.position === 'static') {
    container.style.position = 'relative';
  }

  const mask = document.createElement('div');
  mask.className = MASK_CLASS;
  mask.setAttribute('aria-hidden', 'true');
  container.appendChild(mask);
}

function guardImage(img) {
  if (shouldSkip(img) || img.hasAttribute(GUARDED_ATTR)) return;

  img.setAttribute(GUARDED_ATTR, '1');
  img.setAttribute('draggable', 'false');

  const container = getImageContainer(img);
  if (container) {
    ensureMask(container);
  }
}

function scanRoot(root) {
  if (!root || root.nodeType !== 1) return;
  if (root.tagName === 'IMG') {
    guardImage(root);
  }
  root.querySelectorAll?.('img').forEach(guardImage);
}

/**
 * 全站图片防长按保存。
 * 微信内置浏览器对 img 长按会弹出「保存图片」，对普通 div 不会；
 * 因此 img 设 pointer-events:none，并在容器上盖透明遮罩承接触摸。
 *
 * 白名单：容器或 img 加 class="image-guard-skip"（如订单二维码）。
 * background-image 展示的 banner 本身不是 img，微信一般不会出现「保存图片」。
 *
 * 注意：遮罩 z-index 必须低于底部 Tabbar，且仅在图片容器内叠层（isolation）。
 */
export function setupImageGuard() {
  scanRoot(document.body);
  // 路由/懒加载图片可能在 mounted 之后才插入 DOM
  requestAnimationFrame(() => scanRoot(document.body));
  setTimeout(() => scanRoot(document.body), 500);

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1) {
          scanRoot(node);
        }
      });
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });

  const onContextMenu = (e) => {
    const target = e.target;
    if (
      target.tagName === 'IMG'
      || target.classList?.contains(MASK_CLASS)
    ) {
      e.preventDefault();
    }
  };

  document.addEventListener('contextmenu', onContextMenu, true);

  return () => {
    observer.disconnect();
    document.removeEventListener('contextmenu', onContextMenu, true);
  };
}
